var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.goToUserInfo}},[_c('v-image',{staticClass:"user-photo hover-scale",class:{'is-broadcaster' : _vm.isBroadcaster, 'is-redirect': _vm.isRedirect},attrs:{"image-id":_vm.user.idImage,"default":'DefaultUserPhoto.svg'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }